import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { PostState } from 'types/app';
import { IPostRenderProps } from 'features/posting';
import { PhotoVideoUpload, UserAvatar } from 'components';
import { useCurrentUser, useTimeline } from 'hooks';

interface IProps {
  toggleState: IPostRenderProps['toggleState'];
}

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  header: {
    padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
    marginBottom: theme.spacing(2),
    color: theme.palette.common.white,
  },
  content: {
    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
}));

const CreatePostPlaceholder: FC<IProps> = ({ toggleState }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { timelineGroup } = useTimeline();
  const currentUser = useCurrentUser();
  const backgroundColor = timelineGroup.color_map.hex;

  return (
    <Card className={classes.root}>
      <CardHeader
        style={{ backgroundColor }}
        className={classes.header}
        title={t('posting:createShare')}
        titleTypographyProps={{ variant: 'subtitle2', color: 'inherit' }}
      />
      <CardContent className={classes.content}>
        <Grid container alignItems="center" spacing={2} onClick={() => toggleState(PostState.Edit)}>
          <Grid item>
            <UserAvatar size={40} user={currentUser} />
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle2">{t('posting:prompt')}</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider className={classes.divider} />
      <CardContent className={classes.content}>
        <Grid container>
          <Grid item>
            <PhotoVideoUpload onSave={() => toggleState(PostState.Edit)} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CreatePostPlaceholder;
